var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"layout/inline-flex link/focus:children",attrs:{"href":_vm.linkUrl,"data-gtm":_vm.gtm,"data-moma-link":"icon"}},[_c('span',{staticClass:"link/focus",domProps:{"innerHTML":_vm._s(_vm.svgContent)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }